export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top 5 magasins"])},
        "network_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["réseau"])},
        "view_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir plus"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Top 5 stores"])},
        "network_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["network"])},
        "view_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View more"])}
      }
    }
  })
}
